
export class CssClassMapping {

  public static readonly cssTipiCategoriaFascicolo: { [id: string]: string } = {
    'GIUDIZIALE': 'fasc_giudiziale',
    'STRAGIUDIZIALE': 'fasc_stragiudiziale',
    'ESECUZIONE': 'fasc_esecuzione',
    'OPPOSIZIONE': 'fasc_opposizione',
  };

  public static readonly cssTipiPratica: { [id: string]: string } = {
    '5896d998-53e7-11ea-a08d-005056a8dd09': 'lavoro', // '1'
    '58a00511-53e7-11ea-a08d-005056a8dd09': 'civile', // '2'
    '58a65e7e-53e7-11ea-a08d-005056a8dd09': 'tributario', // '3'
    '58ac8ea5-53e7-11ea-a08d-005056a8dd09': 'amministrativo', // '4'
    '58b1c7d9-53e7-11ea-a08d-005056a8dd09': 'sinistri', // '5'
    '58b65f6c-53e7-11ea-a08d-005056a8dd09': 'penale', // '6'
    '58bc2192-53e7-11ea-a08d-005056a8dd09': 'pareristico' // '7'
  };

  public static readonly cssTipoScadenza: { [id: string]: string } = {
  'UDIENZA' : 'udienza',
  'SCADENZA' : 'scadenza',
  'ATTIVITA' : 'attivita'
  };

  public static readonly cssColorTipoEsitoSpedizione: { [id: string]: string } = {
  'POSITIVO' : 'green',
  'IN_ATTESA_DI_ESITO' : 'yellow',
  'NEGATIVO' : 'red'
  };

  public static readonly cssNameTipoEsitoSpedizione: { [id: string]: string } = {
  'POSITIVO' : 'bassa',
  'IN_ATTESA_DI_ESITO' : 'media',
  'NEGATIVO' : 'alta'
  };

  public static readonly cssNameTipoPriorita: { [id: string]: string } = {
  '1' : 'alta',
  '2' : 'media',
  '3' : 'bassa'
  };

  public static readonly cssColorTipoPriorita: { [id: string]: string } = {
  '1' : 'red',
  '2' : 'yellow',
  '3' : 'green'
  };

  public static readonly cssIconDocumentazioneAllegata: { [id: string]: string } = {
  'application/msword' : 'word',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document' : 'word',
  'application/rtf' : 'word',
  'application/pdf' : 'pdf',
  'application/vnd.ms-excel' : 'excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' : 'excel',
  'image/jpeg' : 'jpg',
  'image/png' : 'jpg',
  'image/bmp' : 'bmp',
  'image/tiff' : 'tiff',
  'application/vnd.ms-powerpoint' : 'ppt',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation' : 'ppt',
  'text/html' : 'html',
  'rfc822' : 'mail',
  'application/vnd.ms-outlook' : 'mail'
  };

  public static readonly cssGestioneAmministrazione: { [id: string]: string } = {
    'anagrafiche': 'anagrafiche',
    'tipologiche': 'tipologiche',
    'tabelle': 'tabelle',
    'associative': 'associative',
    'utenti': 'utenti',
    'gruppi': 'gruppi',
    'profili': 'associative',
    'formulario': 'formulario',
    'scadenzario': 'scadenzario',
    'metadati': 'metadati',
    'tariffe': 'utenti',
    'notifiche': 'notifiche',
    'conservazione': 'conservazione'
  };

}
